export interface CustomFieldValue {
    customFieldId : number;
    value : string | null;
    isSummation: boolean;
}

export function createCustomFieldValue(obj?: CustomFieldValue | any) {
    const result = <CustomFieldValue>{
        customFieldId: 0,
        value: null,
        isSummation: false
    };
    if (obj) {
        Object.assign(result, obj);
    }
    return result;
}